import { config } from '../config';
import { getAccessToken } from '../components/auth/getAccessToken';
import type { AuthTree } from './types';

/**
 * GET /_auth/tree — portfolios and orgs available to the signed-in user.
 */
export async function fetchAuthTree(): Promise<AuthTree> {
  const apiBase = (config.apiBase || config.apiBaseRoot || '').trim().replace(/\/$/, '');
  if (!apiBase) {
    throw new Error('Missing REACT_APP_API_BASE');
  }
  const token = await getAccessToken();
  if (!token) {
    throw new Error('Sign in required');
  }
  const res = await fetch(`${apiBase}/_auth/tree`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) {
    throw new Error(`Auth tree failed (${res.status})`);
  }
  const data = (await res.json()) as AuthTree;
  if (data?.error) {
    throw new Error(typeof data.error === 'string' ? data.error : 'Auth tree error');
  }
  return data;
}
